module.exports = __webpack_public_path__ + "img/1.57616039.jpg";